<template>
  <template v-if="!hasAudioElement">
    <RichTextRenderer
      :html="model.state.html"
      :extra-replacement-tags="model.column?.replacementTags"
      tag="div"
      @endgame="onEndGame"
    />
  </template>
  <template v-if="hasAudioElement && model.state.html">
    <!-- nosem -->
    <div @endgame="onEndGame" v-html="applyReplacementTags(model.state.html, model.column?.replacementTags)"></div>
  </template>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, onMounted, ref } from 'vue';
import type { AddonHTMLModel } from '@/src/components/addons/html-element/Model';
import RichTextRenderer from '@/src/components/RichTextRenderer.vue';
import { applyReplacementTags } from '@/src/utilities/Utilities';
import { appendScriptToHead } from '@/src/utilities/Scripts';
import { endGame } from '@/src/hooks/useEndGame';

export default defineComponent({
  name: 'AddonHtml',
  components: { RichTextRenderer },
  props: {
    model: {
      type: Object as PropType<AddonHTMLModel>,
      required: true
    }
  },
  setup(props) {
    const hasAudioElement = ref(false);
    const scriptElements = ref<string[]>([]);
    const scriptRegEx = /<script+.*>+.*<\/script>/g;

    /**
     * Note: v-html does not support executing scripts - So we need to find alls script tags
     * and pull them into an array and then append these to the body which will execute them
     */
    const scripts = props.model.state.html.match(scriptRegEx);
    if (scripts && scripts.length > 0) {
      scripts.forEach((script) => {
        scriptElements.value.push(script);
      });
    }

    /**
     * Firefox has as issue with audio. If wrapping audio elements
     * in our rich text renderer, it will loop on top of each other, playing the
     * same audio element multiple times, which makes the sound go crazy
     */
    if (props.model.state.html.includes('<audio')) {
      hasAudioElement.value = true;
    }

    /**
     * Execution of script if any exists
     */
    onMounted(() => {
      if (scriptElements.value && scriptElements.value.length > 0) {
        scriptElements.value.forEach((script) => {
          appendScriptToHead(script);
        });
      }
    });

    const onEndGame = (e: CustomEvent<{ winner?: boolean }>) => {
      endGame(!!e.detail.winner);
    };

    return {
      applyReplacementTags,
      hasAudioElement,
      onEndGame
    };
  }
});
</script>

<style lang="scss">
.site--editmode-on {
  object {
    pointer-events: none;
  }
}
</style>
